export const DESCRIPTION_DEFAULT_PLACEHOLDER = 'Add a Description';
export const DESCRIPTION_MAX_LENGTH = 200;
export const EARMARK_WIDTH_SCALE = 6.5;
export const EARMARK_WIDTH_PADDING = 5;
export const EARMARK_TEXT_WIDTH_SCALE = 6.2;
export const THUMBNAIL_HEIGHT_LARGE = '175px';
export const THUMBNAIL_WIDTH_LARGE = '175px';
export const THUMBNAIL_HEIGHT_SMALL = '117px';
export const THUMBNAIL_WIDTH_SMALL = '117px';
export const THUMBNAIL_HEIGHT_EXTRA_SMALL = '100px';
export const THUMBNAIL_WIDTH_EXTRA_SMALL = '100px';
// MultitaggedTile
export const MAX_SINGLE_LINE_FILENAME = 15; // Max length before splitting and Start index for ellipsis insertion
export const MIN_TWO_LINE_FILENAME = 16; // Minimum length requiring two lines
export const THRESHOLD_FOR_DOT_SPLIT_FILENAME = 18; // Threshold for simple dot-split
export const MAX_TOTAL_LENGTH_FILENAME = 30; // Max length before aggressive truncation
export const EXTENSION_OFFSET = 4; // Characters shown before file extension
export const TRUNCATE_MIDDLE_END = 19; // End index for middle truncation segment
export const MAX_DISPLAY_LENGTH_TEXT = 20; // Maximum characters per line before truncation of ext tags
export const ELLIPSIS_BUFFER_TEXT = 3; // Space reserved for ellipsis in truncated lines
export const HORIZONTAL_TILE_WIDTH = '100%'; // Full width for horizontal tile orientation
export const TILE_DIMENSION_ADJUSTMENT = 6; // Standard size adjustment applied to tile dimensions
export const VERTICAL_TEXT_SPACE_THRESHOLD = 1; // Minimum space count to consider text as multi-word in vertical tiles
export const VERTICAL_TEXT_MAX_LENGTH_MULTISPACE = 9; // Max visible characters before truncation when text has more than one space (multi-word) in vertical tiles
export const VERTICAL_TEXT_MULTIWORD_MAX_LENGTH = 10; // Minimum total length for multi-word text to consider for wrapping
export const VERTICAL_TEXT_MAX_LENGTH_SINGLESPACE = 11; // Max visible characters before truncation when text has one or fewer spaces (single/no word boundary) in vertical tiles
export const VERTICAL_TEXT_SHORT_WORD_LENGTH_THRESHOLD = 5; // Threshold for first word length in multi-word tags for margin detection
export const ELIPSIS = '...'; // Standard ellipsis string for truncation
export const LINE_CLAMP = 2; // Number of lines to display before applying ellipsis in vertical tile text
//# sourceMappingURL=constants.js.map